/**
 * transform the url of a youtube video to an embed url. Used to display the video in an iframe
 * @param url 
 * @returns 
 */
export function HandleYouTubeUrl(url: string): string {
    if (!url) return '';
    url = `${url}`;
    
    if (!isYouTubeUrl(url)) return url;

    if(url.includes('embed')) return url;
    if (url.includes('watch?v=')) {
        const urlWithoutParams = url.split('&')[0];
        return urlWithoutParams.replace('watch?v=', 'embed/');
    }
    if(url.includes('youtu.be')){
        return url.replace('youtu.be', 'www.youtube.com/embed');
    }
    return url;
}

function isYouTubeUrl(url: string): boolean {
    return url.includes('youtube') || url.includes('youtu.be');
}